import React, { useEffect, useRef, useState } from 'react'
import { firebase, firestore } from "./firebaseConfig";
// import PaystackForm from './PaystackForm';
import Home from './Components/Home';
import PaystackForm from './Components/Home';
import {BsFillArrowDownCircleFill} from 'react-icons/bs'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import {AiOutlineCloseCircle} from 'react-icons/ai'
import Modal from 'react-modal'
import Banner from '../src/Components/h.png'
import { useParams } from 'react-router-dom';

const Homes = () => {
  const { id } = useParams();
  const [reciept, setReciepts] = useState(false)
  const [transactionData, setTransactionData] = useState(null);
  const [referenceId, setReferenceId] = useState(null);


  const handleReciepts = () =>{
    setReciepts(!reciept)
  }

  const handleAmount = (amount) => { 
    console.log(amount);
  }
  const handleEmail = (email) => { 
    console.log(email);
  }

  const handlePaymentSuccess = async (response, userData)  => {
    console.log("Payment successful:", response);
    
  
    const payeeName = userData.name;
    const payeeEmail = userData.email;
    const payeePrayer = userData.prayer;
    const payeePhoneNumber = userData.phoneNumber;
    const PayeePurpose = userData.purpose;
    const bcsid = "bWlNwAOMpSWgj3Z97t1W";
    const category = "Department";
    const PayeeeBethel = userData.Bethel
    const PayeeMonth = userData.month;
    const PaymentDescription = userData.paymentDescription;
    const PayeeAmount = parseFloat(userData.amount);
  
    const transactionDate = new Date();
    const data = {
      createdAt: transactionDate,
      PayeeAmount,
      PayeePurpose,
      PayeeeBethel,
      payeeName,
      bcsid,
      category,
      payeeEmail,
      payeePrayer,
      PayeeMonth,
      PaymentDescription,
      payeePhoneNumber,
      transactionId: response.reference || response.payments.reference, 
      status: "Successful",
      type: "income",
    };
  
    // Deduct 25 naira as tax
    // const taxAmount = 100;

    // 
    // const addTransaction = async () => {
      // const firestore = firebase.firestore();
      // const usersRef = firestore.collection("Users");
      // const paymentsRef = usersRef.doc("Payments");

      try {
        await firestore.collection("Transactions").add(data);
        console.log("Payment data saved successfully");
      } catch (error) {
        console.error("Error saving payment data: ", error);
      }

          firestore
          .collection("BCS")
          .doc('tj2dBnlhMZLs1aXEVbYT')
          .get()
          .then((balanceDoc) => {
            const currentBalance = balanceDoc.data().balance;
            const newBalance = currentBalance   +  100;
          firestore
            .collection("BCS")
            .doc("tj2dBnlhMZLs1aXEVbYT")
            .set({ balance: newBalance }, {merge: true})
            .then(() => {
              console.log("Tax collection created with initial balance:");
            })
            .catch((error) => {
              console.error("Error creating tax collection:", error);
            })})
            .catch((error) => {
              console.error("Error fetching purpose balance:", error);
            })
        // }
  
        // Fetch the current balance of the selected purpose
        firestore
          .collection("BCS")
          .doc(bcsid)
          .get()
          .then((balanceDoc) => {
            const currentBalance = balanceDoc.exists ? balanceDoc.data().balance : 0;
            const currentBalanceT = balanceDoc.exists ? balanceDoc.data().totalBalance : 0;
            const newBalance = currentBalance   + PayeeAmount - (bcsid === 'tj2dBnlhMZLs1aXEVbYT' ? 0 : 100);
  
            // Update the purpose balance
            firestore
              .collection("BCS")
              .doc(bcsid)
              // .doc(PayeePurpose)
              .set({ balance: newBalance, totalBalance: currentBalanceT + PayeeAmount }, { merge: true })
              .then(() => {
                console.log("Purpose balance updated:", PayeePurpose, newBalance);
                const retrievedReferenceId = response.reference || response.payments.reference;
                   setReferenceId(retrievedReferenceId);
                setTransactionData({
                  paymentId: null,
                  userData: userData,
                  transactionDate: new Date(),
                });
              })
              .catch((error) => {
                console.error("Error updating purpose balance:", error);
              });
          })
          .catch((error) => {
            console.error("Error fetching purpose balance:", error);
          });
      
                    handleReciepts()
      
  };
  

  const handlePaymentClose = () => {
    console.log("Payment cancelled");
  };

  const handleOrderAttempts = (response, userData) => {
    
    const payeeName = userData.name;
    const payeeEmail = userData.email;
    const payeePrayer = userData.prayer;
    const payeePhoneNumber = userData.phoneNumber;
    const PayeePurpose = userData.purpose;
    const bcsid = "bWlNwAOMpSWgj3Z97t1W";
    const category = "Department";
    const PayeeeBethel = userData.Bethel
    const PayeeMonth = userData.month;
    const PaymentDescription = userData.paymentDescription;
    const PayeeAmount = parseFloat(userData.amount);
  
    const transactionDate = new Date();
    const data = {
      createdAt: transactionDate,
      PayeeAmount,
      PayeePurpose,
      PayeeeBethel,
      payeeName,
      bcsid,
      category,
      payeeEmail,
      payeePrayer,
      PayeeMonth,
      PaymentDescription,
      payeePhoneNumber,
      transactionId: 'Flagged Income', 
      status: "Attempt",
      type: "income",
      toggle: false
    };
  
    const addTransaction = async () => {
      // const firestore = firebase.firestore();
      // const usersRef = firestore.collection("Users");
      // const paymentsRef = usersRef.doc("Attempts");
  
      try {
        // Use .add() to create a new transaction with an auto-generated ID
        await firestore.collection("Attempts").add(data);
        console.log("Attempted data saved successfully");
      } catch (error) {
        console.error("Error saving payment data: ", error);
      }
    };
  
    addTransaction();
  }

  // const downloadPDF = () => {
  //   const content = document.getElementById('modal-content');

  //   if (content) {
  //     html2canvas(content).then((canvas) => {
  //       const imgData = canvas.toDataURL('image/png');
  //       const pdf = new jsPDF('p', 'mm', 'a4');
  //       pdf.addImage(imgData, 'PNG', 10, 10, 190, 277);
  //       pdf.save('transaction_details.pdf');
  //     });
  //   }
  // };



  const downloadPDF = () => {
    const content = document.getElementById('modal-content');

    if (content) {
      html2canvas(content).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        pdf.addImage(imgData, 'PNG', 10, 10, 190, 277);
        pdf.save('transaction_details.pdf');
      });
    }
  };

  const [isModalOpen, setIsModalOpen] = useState();

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
 
  return (
    <div  
    // style={{backgroundImage: `url(${Son})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}
    className='text-center  dark:bg-gradient-to-r from-black to-amber-900'>
      <div className='grid justify-center text-center w-[100%] lg:pt-0 pt-10 h'>
<div>
  {/* {!reciept ? 

<div className='absolute z-50 lg:top-52 md:left-56 top-10 left-3 shadow-xl pb-6 bg-white'>
      {transactionData && (
       <div>
          <div id='modal-content'  className='z-50 text-start bg-white p-5 rounded-xl'>
              <h3 className='font-bold text-blue-600 mb-8 mt-4 text-xl'>Transaction Successful</h3>
              <p className='text-xl text-gray-700'>Dear {transactionData.userData.name}. Your Transaction Tracking ID is</p>
              {referenceId ? (
                <p>
                  <b className='text-green-600 underline'>{referenceId}</b>
                </p>
              ): null}
              <p className='text-red-600 mt-3'>Note: Keep make sure you download or write down the ID thanks. BCS Treasury dpt </p>
              <b className='text-green-600 underline'>Amount Paid {transactionData.userData.amount}</b>
              <p className='text-gray-800 mt-4'>Date: {transactionData.transactionDate.toISOString()}</p>
          <button className='bg-green-500 flex p-2 mt-2 rounded-xl text-white font-bold hover:scale-105' onClick={downloadPDF}>Download<BsFillArrowDownCircleFill  className='ml-2 mt-1'/></button>
          </div>
          <a href="/" className='font-bold flex ml-6 text-red-600 hover:bg-red-600 hover:text-white p-2 rounded-md border-2 border-red-600 duration-700 text-xl'>close <AiOutlineCloseCircle  className='ml-2 mt-1'/></a>
       </div>
      )}
      </div> :null
} */}
   {transactionData && (
        <Modal className="ml-[20%] bg-gray-200 text-center p-5 inset-0 flex items-center justify-center w-[50%]"
          isOpen={true} // You can manage the modal open/close state
          onClose={() => setTransactionData(null)}
          contentLabel="Example Modal"
        >
          <div id='modal-content'  className='z-50 text-start bg-white p-5 rounded-xl'>
              <img src={Banner} alt="logo" className='flex justify-self-center' />
              <h3 className='font-bold text-blue-600 mb-8 mt-4 text-xl'>Transaction Successful</h3>
              <p className='text-xl text-gray-700'>Dear {transactionData.userData.name}. Your Payment To {transactionData.userData?.purpose} Tracking ID is</p>
              {referenceId ? (
                <p>
                  <b className='text-green-600 underline'>{referenceId}</b>
                </p>
              ): null}
              <p className='text-red-600 mt-3'>Note: Download or write down the ID thanks. BCS Treasury Department</p>
              <b className='text-green-600 underline'>Amount Paid {transactionData.userData.amount}</b>
              <p className='text-gray-800 mt-4'>Date: {transactionData.transactionDate.toISOString()}</p>
          <button className='bg-green-500 flex p-2 mt-2 rounded-xl text-white font-bold hover:scale-105' onClick={downloadPDF}>Download<BsFillArrowDownCircleFill  className='ml-2 mt-1'/></button>
          </div>
          <a href="/" className='font-bold flex ml-6 text-red-600 hover:bg-red-600 hover:text-white p-2 rounded-md border-2 border-red-600 duration-700 text-xl'>close <AiOutlineCloseCircle  className='ml-2 mt-1'/></a>
        </Modal>
      )}
</div>
      <div>
      </div>
      </div>
        <div
                variant="success"
              >
                <PaystackForm
                  amountCallback={handleAmount} 
                  email={handleEmail} 
                  onSuccess={handlePaymentSuccess}
                  onClose={handlePaymentClose}
                  handleOrderAttempts={handleOrderAttempts}
                />
              </div>


    </div>
  )
}

export default Homes


